import type React from "react";
import { cn } from "src/shadcn/lib/utils";
import {
  DropdownMenu as ShadcnDropdownMenu,
  DropdownMenuPortal as ShadcnDropdownMenuPortal,
  DropdownMenuTrigger as ShadcnDropdownMenuTrigger,
  DropdownMenuContent as ShadcnDropdownMenuContent,
  DropdownMenuGroup as ShadcnDropdownMenuGroup,
  DropdownMenuLabel as ShadcnDropdownMenuLabel,
  DropdownMenuItem as ShadcnDropdownMenuItem,
  DropdownMenuCheckboxItem as ShadcnDropdownMenuCheckboxItem,
  DropdownMenuRadioGroup as ShadcnDropdownMenuRadioGroup,
  DropdownMenuRadioItem as ShadcnDropdownMenuRadioItem,
  DropdownMenuSeparator as ShadcnDropdownMenuSeparator,
  DropdownMenuShortcut as ShadcnDropdownMenuShortcut,
  DropdownMenuSub as ShadcnDropdownMenuSub,
  DropdownMenuSubTrigger as ShadcnDropdownMenuSubTrigger,
  DropdownMenuSubContent as ShadcnDropdownMenuSubContent,
} from "src/shadcn/components/dropdown-menu";

const DropdownMenu = (
  props: React.ComponentProps<typeof ShadcnDropdownMenu>
) => <ShadcnDropdownMenu {...props} />;

const DropdownMenuPortal = (
  props: React.ComponentProps<typeof ShadcnDropdownMenuPortal>
) => <ShadcnDropdownMenuPortal {...props} />;

const DropdownMenuTrigger = (
  props: React.ComponentProps<typeof ShadcnDropdownMenuTrigger>
) => <ShadcnDropdownMenuTrigger {...props} />;

const DropdownMenuContent = (
  props: React.ComponentProps<typeof ShadcnDropdownMenuContent>
) => <ShadcnDropdownMenuContent {...props} />;

const DropdownMenuGroup = (
  props: React.ComponentProps<typeof ShadcnDropdownMenuGroup>
) => <ShadcnDropdownMenuGroup {...props} />;

const DropdownMenuLabel = (
  props: React.ComponentProps<typeof ShadcnDropdownMenuLabel>
) => <ShadcnDropdownMenuLabel {...props} />;

const DropdownMenuItem = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnDropdownMenuItem>) => (
  <ShadcnDropdownMenuItem
    className={cn("cursor-pointer", className)}
    {...props}
  />
);

const DropdownMenuCheckboxItem = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnDropdownMenuCheckboxItem>) => (
  <ShadcnDropdownMenuCheckboxItem
    className={cn("cursor-pointer", className)}
    {...props}
  />
);

const DropdownMenuRadioGroup = (
  props: React.ComponentProps<typeof ShadcnDropdownMenuRadioGroup>
) => <ShadcnDropdownMenuRadioGroup {...props} />;

const DropdownMenuRadioItem = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnDropdownMenuRadioItem>) => (
  <ShadcnDropdownMenuRadioItem
    className={cn("cursor-pointer", className)}
    {...props}
  />
);

const DropdownMenuSeparator = (
  props: React.ComponentProps<typeof ShadcnDropdownMenuSeparator>
) => <ShadcnDropdownMenuSeparator {...props} />;

const DropdownMenuShortcut = (
  props: React.ComponentProps<typeof ShadcnDropdownMenuShortcut>
) => <ShadcnDropdownMenuShortcut {...props} />;

const DropdownMenuSub = (
  props: React.ComponentProps<typeof ShadcnDropdownMenuSub>
) => <ShadcnDropdownMenuSub {...props} />;

const DropdownMenuSubTrigger = ({
  className,
  ...props
}: React.ComponentProps<typeof ShadcnDropdownMenuSubTrigger>) => (
  <ShadcnDropdownMenuSubTrigger
    className={cn("cursor-pointer", className)}
    {...props}
  />
);

const DropdownMenuSubContent = (
  props: React.ComponentProps<typeof ShadcnDropdownMenuSubContent>
) => <ShadcnDropdownMenuSubContent {...props} />;

export {
  DropdownMenu,
  DropdownMenuPortal,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuLabel,
  DropdownMenuItem,
  DropdownMenuCheckboxItem,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuShortcut,
  DropdownMenuSub,
  DropdownMenuSubTrigger,
  DropdownMenuSubContent,
};
